import React, {Fragment} from "react";
import {ActionType} from "../list/list/DataTable";
import {
    BonusStatus,
    DepositRewardConfig,
    DepositRewardConfigListRequest,
} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {ListView, ListViewProps, ListViewState} from "../ListView";
import {DepositRewardConfigService} from "../../services/DepositRewardConfigService";
import {ColumnType} from "../list/list/ColumnType";

interface State extends ListViewState<DepositRewardConfigListRequest> {
    validationMap?: any;
}

export class DepositRewardConfigListView extends ListView<State, DepositRewardConfigListRequest> {

    columns = [
        {
            property: "status",
            name: "Status",
            renderer: (property: string, name: string, item: any) => {
                let backgroundColor = '';
                if (item["status"] === BonusStatus.ENABLED) {
                    backgroundColor = '#28A745';
                } else if (item["status"] === BonusStatus.DISABLED) {
                    backgroundColor = '#F1556C';
                }
                return <span style={{backgroundColor}} className={"dot"} title={item["status"]}/>
            }
        },
        {property: "id", name: "ID", orderBy: "id"},
        {property: "name", name: "Name"},
        {property: "validFromDate", name: "Valid From", type: ColumnType.DATE},
        {property: "validToDate", name: "Valid To", type: ColumnType.DATE},
        {property: "expiresAfterDays", name: "Expires Days"},
    ];

    actions = [
        {id: "view", name: "Edit", className: "btn btn-primary", iconClassName: "fa fa-edit", type: ActionType.LINK, getLink: (item: any) => "/bonus/deposit-reward/" + item.id},
        {id: "delete", name: "Delete", className: "btn btn-danger", iconClassName: "fa fa-trash", type: ActionType.CONFIRMATION}
    ];

    service: DepositRewardConfigService;

    constructor(props: ListViewProps) {
        super(props, "/bonus/deposit-rewards/list");
        this.state = {...this.state, validationMap: {}};
        this.service = getContainer().getDepositRewardConfigService();
    }

    onAction(item: DepositRewardConfig, action: string): Promise<any> | undefined {
        if (action == "delete") {
            return this.service.remove("" + item.id);
        }
    }

    pagerChanged(pager: PagerModel) {
        if (this.state.listRequest) {
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest, pager);
            this.updateListState(listRequest);
        }
    }

    getTitle() {
        return "Deposit Reward Configurations";
    }

    renderContent() {
        if (!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}/>
            </Fragment>
        );
    }
}

export default withRouter(DepositRewardConfigListView);
